import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { AuthShell } from "@/pages/Login";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("If an account exists, a reset link is on its way.");
    } catch (err) { toast.error(apiError(err)); } finally { setBusy(false); }
  };

  return (
    <AuthShell title="Reset your password" subtitle="We'll email you a secure link to set a new password.">
      {sent ? (
        <div className="text-center py-4">
          <p className="text-slate-600 text-sm">Check your inbox for a reset link. It expires in one hour.</p>
          <Button asChild className="mt-6 rounded-full bg-amber hover:bg-amber-600 text-white"><Link to="/login">Back to sign in</Link></Button>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" className="mt-1" />
          </div>
          <Button type="submit" disabled={busy} data-testid="forgot-submit" className="w-full rounded-full bg-amber hover:bg-amber-600 text-white font-semibold">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send reset link"}
          </Button>
          <p className="text-center text-sm text-slate-500"><Link to="/login" className="text-amber font-semibold">Back to sign in</Link></p>
        </form>
      )}
    </AuthShell>
  );
}
